import { AddressFieldInfo } from "./address-field-info.class";

export class TextAddressFieldInfo extends AddressFieldInfo { }